import { observable, action } from 'mobx';

export default class StepTime {

    @observable allStartTime = ''; // 总开始时间

    @observable allEndTime = ''  // 总结束时间

    @observable stepArray = []; // 操作步骤调试数据

    @action setStepTime(date) {
      this.stepArray.push(date) // 记录操作步骤数据
    }
}

export const stepTime = new StepTime();